export default "/images/dropdown.svg?7018f4ecd0cc9009f94177a0f555abef";